import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';
import { getConditionalEventsReport } from '../services/conditionalEventsReport';
import { ConditionalEventsReportSlice } from '../types';
import { formatConditionalEventsReportItem } from '../utils/helpers';
import { ReportsSlice, ReportType } from '../../../types';

export const conditionalEventsInitialState: ConditionalEventsReportSlice = {
  isFailed: false,
  isLoading: false,
  transports: {},
};

export const resetState = createAction('conditionalEvents/resetState');

export const conditionalEventsReducers = (
  builder: ActionReducerMapBuilder<ReportsSlice<ConditionalEventsReportSlice>>,
) => {
  builder.addCase(getConditionalEventsReport.pending, (state) => {
    state[ReportType.CONDITIONAL_EVENTS].isLoading = true;
  });

  builder.addCase(getConditionalEventsReport.fulfilled, (state, action) => {
    state[ReportType.CONDITIONAL_EVENTS].isLoading = false;

    Object.entries(action.payload.transports).forEach(([key, value]) => {
      state[ReportType.CONDITIONAL_EVENTS].transports[Number(key)] =
        value.items.map((item) =>
          formatConditionalEventsReportItem(
            Number(key),
            item,
            value.name,
            value.licensePlate,
          ),
        );
    });
  });

  builder.addCase(getConditionalEventsReport.rejected, (state) => {
    state[ReportType.CONDITIONAL_EVENTS].isLoading = false;
    state[ReportType.CONDITIONAL_EVENTS].isFailed = true;
  });

  builder.addCase(resetState, (state) => {
    state[ReportType.CONDITIONAL_EVENTS] = conditionalEventsInitialState;
  });
};
